import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ForgotPasswordDone, ForgotPasswordEmail } from './components';

export const ForgotPasswordPage = () => {
  const [succeeded, setSucceeded] = useState(false);
  const navigate = useNavigate();

  const handleComplete = useCallback(() => navigate('/login'), [navigate]);

  return succeeded ? (
    <ForgotPasswordDone onComplete={handleComplete} />
  ) : (
    <ForgotPasswordEmail onComplete={() => setSucceeded(true)} />
  );
};
